import 'jquery';

/**
 * toggles visibility of elements by selecting checkboxes
 *
 */
(function ($) {

  let input = $(':input[data-toggle-show], :input[data-toggle-hide]'),
    toggle = function (input) {
      let showTarget = input.data('toggle-show') ? $(input.data('toggle-show')) : $(),
        hideTarget = input.data('toggle-hide') ? $(input.data('toggle-hide')) : $();

      if (
        (input.attr('type') === 'hidden' && !input.val() && input.is('[data-toggle-hide]')) ||
        (input.attr('type') === 'hidden' && input.val() && input.is('[data-toggle-show]')) ||
        (input.is(':checkbox') && input.is(':checked') && input.is('[data-toggle-show]')) ||
        (input.is(':checkbox') && input.not(':checked') && input.is('[data-toggle-hide]'))
      ) {
        showTarget.show();
        hideTarget.hide();
      } else {
        showTarget.hide();
        hideTarget.show();
      }

      $('body').trigger('plenigo.resize', { scroll: true });
    };

  input.on('change', function () {
    toggle($(this));
  })
    .each(function () {
      toggle($(this));
    });

}(jQuery));
